import { parseFilters } from '../../../libs/filter.lib'
import {
  QueryStringFilter,
  QueryStringSort,
} from '../../../models/query-string.model'
import {
  CatalogField,
  CatalogSearchParams,
  CatalogSortField,
} from '../models/catalog-search.model'

export function parseCatalogFilters(
  params: CatalogSearchParams,
  filters: CatalogSearchParams,
): CatalogSearchParams {
  return parseFilters(params, filters, catalogFilterParams)
}

/**
 * Parse catalog sort params
 * @param params - the search params
 * @param sort - the sort param value
 * @returns the catalog search params updated
 */
export function catalogSortParams(
  params: CatalogSearchParams,
  sort: QueryStringSort<CatalogSortField>,
): CatalogSearchParams {
  const searchParams: CatalogSearchParams = {}

  switch (sort.field) {
    case 'name':
      searchParams.sort = 'name'
      searchParams.order = sort.order
      break
    case 'code':
      searchParams.sort = 'code'
      searchParams.order = sort.order
      break
  }

  return {
    ...params,
    ...searchParams,
  }
}

/**
 * Parse catalog filter params
 * @param params - the search params
 * @param filter - the filter param value
 * @returns the catalog search params updated
 */
export function catalogFilterParams(
  params: CatalogSearchParams,
  filter: QueryStringFilter<CatalogField>,
): CatalogSearchParams {
  const searchParams: CatalogSearchParams = {}

  switch (filter.field) {
    case '_id':
      if (filter.operator === '=') {
        searchParams._id = filter.value
      }
      break
    case 'name':
      if (filter.operator === '=') {
        searchParams.name = filter.value
      } else if (filter.operator === 'contains') {
        searchParams['name:ct'] = filter.value
      }
      break
    case 'code':
      if (filter.operator === '=') {
        searchParams.code = filter.value
      } else if (filter.operator === 'contains') {
        searchParams['code:ct'] = filter.value
      }
      break
  }

  return {
    ...params,
    ...searchParams,
  }
}
